import { render, staticRenderFns } from "./ApproverLeaveHistory.vue?vue&type=template&id=67be0963&scoped=true&"
import script from "./ApproverLeaveHistory.vue?vue&type=script&lang=js&"
export * from "./ApproverLeaveHistory.vue?vue&type=script&lang=js&"
import style0 from "./ApproverLeaveHistory.vue?vue&type=style&index=0&id=67be0963&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be0963",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDatePicker,VIcon,VMenu,VSelect,VTextField})
